module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Check the size recommended by AI"}}')
  delete Component.options._Ctor
}
